(function () {
'use strict';

(function(rum) {
    rum.logError = function (params, error, settingsFromError) {
        params = params || {};

        if (typeof error === 'string' || typeof error === 'undefined') {
            error = new Error(error);
            error.justCreated = true;
        }

        var message = params.message || '',
            err = rum._baseNormalizeError(error);

        if (err.message && !params.ignoreErrorMessage) {
            if (message) {
                message += '; ';
            }

            message += err.message;
        }

        err.message = message || 'Empty error';

        var fields = ['service', 'source', 'type', 'block', 'additional', 'level', 'page', 'method', 'sourceMethod', 'coordinates_gp'];

        for (var i = 0; i < fields.length; i++) {
            var name = fields[i];

            if (params[name]) {
                err[name] = params[name];
            } else if (error && error[name]) {
                err[name] = error[name];
            }
        }

        rum._handleError(err, true, settingsFromError);
    };
})(Ya.Rum);

}());
